export const environment = {
  production: false,
  isKiosk: false,
  // Stack nuevo (single entry point): las URLs son relativas al gateway,
  // que enruta /api/* al backend interno. Mismo origen => Sanctum stateful
  // sin CORS. El Angular 22 va sobre la API v2 íntegramente.
  apiUrl:       '/api/',
  apiProneUrl:  '/api/station/',
};
